import { IDDiagnosisNull } from 'models/DCK/basicInterface';
import { DiagnosisStatus } from 'utils/statusCode';

export const getDiagnosisStatus = (diagnosisInfo: IDDiagnosisNull) => {
    if (!diagnosisInfo || diagnosisInfo.status === undefined) return '';

    switch (diagnosisInfo.status) {
        case DiagnosisStatus.delete:
            return 'delete';
        case DiagnosisStatus.notAssigned:
            return 'notAssigned';
        case DiagnosisStatus.pending:
            return 'pending';
        case DiagnosisStatus.inProgress:
            return 'inProgress';
        case DiagnosisStatus.completed:
            return 'completed';
        case DiagnosisStatus.counselReserved:
            if (diagnosisInfo.noShowDisabled) {
                return 'reschedule';
            } else {
                return 'counselReserved';
            }
        case DiagnosisStatus.counselComplete:
            if (diagnosisInfo.noShowDisabled && diagnosisInfo.noShowInfo?.length === 2) {
                return 'noshow';
            } else return 'counselComplete';
        default:
            return '';
    }
};

export const getNoShowModalContent = (diagnosisInfo: IDDiagnosisNull) => {
    if (getDiagnosisStatus(diagnosisInfo!) === 'counselReserved' && diagnosisInfo.noShowInfo?.length === 1) {
        return { firstContent: '노쇼 2회로 처리한 후에는 상담이 종료됩니다.', secondContent: '' };
    } else {
        return { firstContent: '노쇼 1회로 처리 후에는 아래의 연락처를 통해', secondContent: '새로운 일정을 정하여 변경해주세요.' };
    }
};
